module.exports = __webpack_public_path__ + "img/icon-arrow-white.a977ea29.svg";